import { createContext } from 'react';

const SensorsContext = createContext([]);

export default SensorsContext;